import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Global/Buttons/Button';
import IconWithText from '../Global/Icons/IconWithText';

const SessionNav = ({ changeDrill }) => (
  <div className="previous-next-btns">
    <Button onClick={() => changeDrill('previous')} classes="previous-btn" faux>
      <IconWithText name="arrow-long-left" size="m" fill="green">Previous</IconWithText>
    </Button>
    <Button onClick={() => changeDrill('next')} classes="next-btn" faux>
      <IconWithText name="arrow-long-right" size="m" fill="green" iconRight>Next</IconWithText>
    </Button>
  </div>
);

SessionNav.propTypes = {
  changeDrill: PropTypes.func,
};

export default SessionNav;



// WEBPACK FOOTER //
// ./library/app/components/Session/SessionNav.js